export default __webpack_public_path__ + "static/media/basket-header.860da972.png";